import React from "react";
import LoadingIcon from "mdi-react/LoadingIcon";
import { Card, CardBody, Col } from "react-bootstrap";

const PanelComponent = ({
  xs = 0,
  sm = 0,
  md = 0,
  lg = 0,
  xl = 0,
  title = "",
  panelClass = "",
  buttonText = null,
  callback = () => {},
  icon = null,
  isSpinner,
  children,
}) => {
  return (
    <Col md={md} lg={lg} xl={xl} sm={sm} xs={xs}>
      <Card className={`panel ${panelClass}`}>
        <CardBody className="Panel-body">
          {isSpinner && (
            <div className="panel-spinner">
              <LoadingIcon />
            </div>
          )}
          <div className="panel-header mb-3 container-fluid">
            <div className="row">
              <div className={`${buttonText ? "col-6" : "col-12"}`}>
                <div className="panel-title">
                  <h5>{title}</h5>
                </div>
              </div>
              {buttonText && (
                <div className="col-6">
                  <div className="panel-btn text-end">
                    <button type="button" onClick={() => callback()}>
                      {buttonText}
                      {icon && <img src={icon} alt="edit-icon" />}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="panel-content">{children}</div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PanelComponent;
